<div
  class="sz-row-card"
  [class.sz-row-card--flat]="variant() === 'flat'"
  [class.sz-row-card--featured]="variant() === 'featured'"
  [class.sz-row-card--subtle]="variant() === 'subtle'"
  [class.sz-row-card--dashed]="variant() === 'dashed'"
  [class.sz-row-card--interactive]="interactive()">
  <div class="sz-row-card__lead">
    <ng-content select="[szRowLead]" />
  </div>
  <div class="sz-row-card__body">
    <ng-content />
  </div>
  <div class="sz-row-card__end">
    <ng-content select="[szRowEnd]" />
  </div>
</div>
